import * as types from './types';

export const approveRequest = (data) => ({ type: types.APPROVE_REQUEST, data });
export const approveRequestFailure = (error) => ({ type: types.APPROVE_REQUEST_FAILURE, error });
export const approveRequestSuccess = (data) => ({ type: types.APPROVE_REQUEST_SUCCESS, data });

export const declineRequest = (data) => ({ type: types.DECLINE_REQUEST, data });
export const declineRequestFailure = (error) => ({ type: types.DECLINE_REQUEST_FAILURE, error });
export const declineRequestSuccess = (data) => ({ type: types.DECLINE_REQUEST_SUCCESS, data });

export const getDoneApprovalsRequest = (data) => ({ type: types.GET_DONE_APPROVALS_REQUEST, data });
export const getDoneApprovalsRequestFailure = (error) => ({ type: types.GET_DONE_APPROVALS_REQUEST_FAILURE, error });
export const getDoneApprovalsRequestSuccess = (data) => ({ type: types.GET_DONE_APPROVALS_REQUEST_SUCCESS, data });

export const getTodoApprovalsRequest = (data) => ({ type: types.GET_TODO_APPROVALS_REQUEST, data });
export const getTodoApprovalsRequestFailure = (error) => ({ type: types.GET_TODO_APPROVALS_REQUEST_FAILURE, error });
export const getTodoApprovalsRequestSuccess = (data) => ({ type: types.GET_TODO_APPROVALS_REQUEST_SUCCESS, data });
